/**
 * ENCODING enum.
 * 
 * KotOR JS - A remake of the Odyssey Game Engine that powered KotOR I & II
 * 
 * @file ENCODING.ts
 * @author KobaltBlu <https://github.com/KobaltBlu>
 * @license {@link https://www.gnu.org/licenses/gpl-3.0.txt|GPLv3}
 * @enum
 */
export enum ENCODING {
  GRAY = 1,
  RGB = 2,
  RGBA = 4,
  BGRA = 12
}